import { useCallback } from 'react';
import type { Permission } from '@bruhat/shared';
import { useAuthStore } from '@/store/auth.store';

/**
 * UI-side permission checks. These only hide affordances — the server
 * independently rejects anything the caller is not entitled to, so a bug here
 * cannot become a security hole.
 */
export function usePermissions() {
  const profile = useAuthStore((s) => s.profile);

  const can = useCallback(
    (permission: Permission) => useAuthStore.getState().can(permission),
    [],
  );

  const canAny = useCallback(
    (...permissions: Permission[]) => permissions.some((p) => useAuthStore.getState().can(p)),
    [],
  );

  return {
    can,
    canAny,
    userId: profile?.id,
    roles: profile?.roles ?? [],
    isSuperAdmin: profile?.isSuperAdmin ?? false,
    projectIds: profile?.projectIds ?? [],
  };
}
